import { useState } from 'react';

import type { EntryData } from 'chaika-frontend-types/frontend-cms';
import { Optional } from 'chaika-common-types';

import { entryService } from '@patient/services/entry/entryService';
import { OptionType } from '@components/Select';
import { store } from '@store';

interface Params {
    entry: EntryData;
}

interface UseDoctorForm {
    inDoor: boolean;
    deviceId: Optional<string>;
    onInDoorChange(): void;
    onDeviceChange(value: OptionType<string>): void;
}

export function useEntryDataForm({ entry }: Params): UseDoctorForm {
    const [inDoor, setInDoor] = useState<boolean>(entry.inDoor);
    const [deviceId, setDeviceId] = useState<Optional<string>>(entry.deviceId);

    async function onInDoorChange(): Promise<void> {
        const { app } = store;

        await app.doOrShowError({
            action: async () => {
                await entryService.toggleInDoor();
                setInDoor(!inDoor);
            },
        });
    }

    async function onDeviceChange({ value }: OptionType<string>): Promise<void> {
        const { app } = store;

        await app.doOrShowError({
            action: async () => {
                await entryService.updateDevice(value);
                setDeviceId(value);
            },
        });
    }

    return {
        inDoor,
        deviceId,
        onInDoorChange,
        onDeviceChange,
    };
}
